import { render, staticRenderFns } from "./FolderNotificationHistoryDialog.vue?vue&type=template&id=42921b9c&scoped=true"
import script from "./FolderNotificationHistoryDialog.vue?vue&type=script&lang=js"
export * from "./FolderNotificationHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderNotificationHistoryDialog.vue?vue&type=style&index=0&id=42921b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42921b9c",
  null
  
)

export default component.exports